import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingSection',
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})